import { MdMenu } from "react-icons/md";
import { IoMdPrint } from "react-icons/io";
import React, {useEffect, useState,useRef} from "react";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "./form8Data.css";
import {useSelector,useDispatch} from "react-redux";
import {BaseURL} from "../../../API/API";
import {addAllInFrom8, deleteForm8DataByIndex, setForm8Data} from "../../Redux/Reduser/Reducer";
import ReactPaginate from "react-paginate";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import TaxReceiptPage from "../../TaxReceipt/TaxReceiptPage";
import CsvSearch from "../../CsvSearch/CsvSearch";
import * as XLSX from "xlsx";


export  function Form8DataOld() {
    const [gruhkar,setGruhkar]=useState([]);
    const [panikar,setPanikar]=useState([]);


    const navigate = useNavigate();
    const tableRef = useRef();
    const [form8Data,setForm8Data]=useState([]);
    const [allData,setAllData]=useState([]);
    const [sortOrder, setSortOrder] = useState('asc');
    const [isTaxReceipt,setIsTaxReceipt]=useState(false);
    const [searchType,setSearchType]=useState("All")
    const [searchText,setSearchText]=useState("")
    const [activePage,setActivePage]=useState(0);
    const [pageCount,setPageCount]=useState(0);
    const [totalRecord,setTotalRecord]=useState(0);

    const [isAcending,setIsAcending]=useState(false);


    useEffect(()=>{
       // ReadGruhkar();
       // ReadPanikar();
    },[])

    function ReadGruhkar() {
        fetch('/output_clean_data.csv')
            .then((response) => response.arrayBuffer())
            .then((buffer) => {
                const workbook = XLSX.read(buffer, { type: 'array',raw: true,
                    cellDates: false });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // Convert to JSON array
                const jsonData = XLSX.utils.sheet_to_json(worksheet,{ defval: "" });
                // console.log(jsonData)
                setGruhkar(jsonData);
            })
            .catch((error) => console.error('Error reading CSV file:', error));
    }
    function ReadPanikar() {
        fetch('/output_clean_data2.csv')
            .then((response) => response.arrayBuffer())
            .then((buffer) => {
                const workbook = XLSX.read(buffer, {
                    type: 'array',
                    raw: true,
                    cellDates: false
                });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // Convert to JSON array
                const jsonData = XLSX.utils.sheet_to_json(worksheet,{ defval: "" });
                setPanikar(jsonData);
            })
            .catch((error) => console.error('Error reading CSV file:', error));
    }


    useEffect(() => {
        CountPage();
    }, []);

    useEffect(()=>{
        ReadRecord();
        //ReadRecordNew();
    },[activePage])

    function Add() {
        navigate("/admin/Form8AddInformation");
    }
    function Search() {
        // CountPage();
        // ReadRecord();
        SearchRecord(searchType,searchText);
    }

    function SearchRecord(type, text) {
        if (!text.trim() || type === "All") {
            setForm8Data(allData);
            return;
        }

        const filteredData = allData.filter(item => {
            const value = (item[type] || "").toString().toLowerCase();
            return value.includes(text.toLowerCase());
        });

        setForm8Data(filteredData);
    }
    const handlePrint = () => {
        const printWindow = window.open("", "", "height=800,width=1000");

        printWindow.document.write(`
    <html>
      <head>
        <title>Print Table</title>
        <style>
          @media print {
            @page {
              size: legal portrait;
              margin: 5px;
              margin-top: 100px;
            }

            th:first-child,
            td:first-child {
              display: none;
            }

            body {
              margin: 0;
            }
          }

          body {
            font-family: Arial, sans-serif;
            padding: 10px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            page-break-inside: auto;
          }

          th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
            vertical-align: top;
          }

          th {
            background-color: #3f51b5;
            color: white;
            font-weight: bold;
          }

          tr:nth-child(even) {
            background-color: #f2f2f2;
          }

          tr:hover {
            background-color: #e0e0e0;
          }
        </style>
      </head>
      <body>
        ${document.getElementById("TableList").innerHTML}
      </body>
    </html>
  `);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };


    function ReadRecord() {
        let form = new FormData();
        form.append('VilageName',JSON.parse(sessionStorage.getItem('data'))[0].VilageName.trim());
        form.append('searchType',searchType);
        form.append('activePage',activePage);
        form.append('searchText',searchText);

        fetch(BaseURL + 'GM.php/ReadForm8', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                try {

                    const sortedData = JSON.parse(data).sort((a, b) => {
                        const valA = (a.Property_No || '').trim();
                        const valB = (b.Property_No || '').trim();

                        // Empty values last
                        if (!valA) return 1;
                        if (!valB) return -1;

                        const [mainA, subA = 0] = valA.split('/').map(Number);
                        const [mainB, subB = 0] = valB.split('/').map(Number);

                        if (mainA !== mainB) {
                            return mainA - mainB;
                        }

                        return subA - subB;
                    });
                    const rawData = JSON.parse(data);
                    // const sortedData = sortPropertyNumbers(rawData);

                    setForm8Data(sortedData);
                    setAllData(sortedData);
                } catch (e) {
                    console.error("Parsing error:", e);
                }
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });
    }
    function CountPage() {
        setActivePage(0);
        let form = new FormData();
        form.append('VilageName',JSON.parse(sessionStorage.getItem('data'))[0].VilageName);
        form.append('searchType',searchType);
        form.append('searchText',searchText);

        fetch(BaseURL + 'GM.php/ReadForm8Count', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                try {
                     const parsedData = JSON.parse(data); // First level parse
                    setTotalRecord(JSON.parse(parsedData)[0].total);
                    if(parseInt(JSON.parse(parsedData)[0].total)%20===0){
                        setPageCount(parseInt(JSON.parse(parsedData)[0].total/20));
                    }else{
                        setPageCount(parseInt(JSON.parse(parsedData)[0].total/20+1));
                    }
                    PrintAll();
                } catch (e) {
                    console.error("Parsing error:", e);
                }
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });

    }
    async function PrintAll() {
        let allData = [];

        const requests = [];

        for (let i = 1; i <= pageCount; i++) {
            const form = new FormData();
            form.append('VilageName', JSON.parse(sessionStorage.getItem('data'))[0].VilageName.trim());
            form.append('searchType', searchType);
            form.append('activePage', i);
            form.append('searchText', searchText);

            const request = fetch(BaseURL + 'GM.php/ReadForm8', {
                method: 'POST',
                body: form
            }).then(res => res.text())
                .then(data => {
                    if (data !== "[]") {
                        try {
                            const parsedData = JSON.parse(data);
                            if (typeof parsedData === 'string') {
                                const innerParsed = JSON.parse(parsedData);
                                innerParsed.forEach((item)=>{
                                    allData.push(item);
                                });
                           }
                        } catch (e) {
                            console.error("Parsing error:", e);
                        }
                    }
                }).catch(err => {
                    console.error("Fetch error:", err);
                });

            requests.push(request);
        }

        // Wait for all fetch requests to complete
        await Promise.all(requests);
        setForm8Data(allData);
        alert("Press print button");
    }

    // Button Click event ke liye function
    const handleSortClick = () => {
        // Current order ko toggle karein (asc -> desc ya desc -> asc)
        const nextOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(nextOrder);

        // Current form8Data ko copy karke sort karein
        const sorted = [...form8Data].sort((a, b) => {
            const valA = (a && a.Property_No !== undefined && a.Property_No !== null)
                ? String(a.Property_No).trim()
                : '';
            const valB = (b && b.Property_No !== undefined && b.Property_No !== null)
                ? String(b.Property_No).trim()
                : '';

            // Empty values ko hamesha LAST me rakhne ke liye
            if (!valA && !valB) return 0;
            if (!valA) return 1;
            if (!valB) return -1;

            // Natural numeric comparison (1, 2, 2/1, 3, 10...)
            const comparison = valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' });

            // Ascending / Descending check
            return nextOrder === 'asc' ? comparison : -comparison;
        });

        // States Update Karein
        setForm8Data(sorted);
        setAllData(sorted);
    };
    function Sort() {
        handleSortClick();
    }



    if(isTaxReceipt){
        //return <CsvSearch/>
        return <TaxReceiptPage gruhkar={gruhkar}
    panikar={panikar} setIsTaxReceipt={setIsTaxReceipt} Data={form8Data} />
    }


    return <>
        <div className="mt-2 p-3 card">
            <h1>Form8</h1>
            ग्रामपंचायत नमूना ८
        </div>

        <div className="card">
            <h4>Total:{totalRecord}</h4>
            <div className="d-flex justify-content-between">
                <div className="mt-2 p-3">
                    {/*<span className={"m-1"}><MdMenu/></span>*/}
                    <span onClick={handlePrint} className={"m-1"}><IoMdPrint/></span>
                    <button onClick={PrintAll} className="btn btn-primary m-1">Print All</button>
                    <button onClick={Sort} className="btn btn-primary">Sort</button>
                    <button onClick={()=>setIsTaxReceipt(true)} className="btn btn-primary m-1">Tax Receipt</button>
                </div>
                <div className="mt-2 p-3">
                    <select onChange={(e)=>setSearchType(e.target.value)} className="form-control d-inline-block w-auto" name="selSearch">
                        <option value="All">All</option>
                        <option value="Property_No">मालमत्ता क्र.</option>
                        {/*<option value="GramPanchayat_Name1">गाव</option>*/}
                        <option value="Owner_Name">घरमालकाचे नाव</option>
                    </select>
                    <input onChange={(e)=>setSearchText(e.target.value)} className="form-control d-inline-block w-auto mx-2" />
                    <button onClick={Search} className="btn btn-primary d-inline-block">Search</button>
                    <button onClick={Add} className="btn btn-primary d-inline-block mx-2">Add</button>
                </div>
            </div>

            <Table form8Data={form8Data}
                   tableRef={tableRef}
                   isAcending={isAcending}
            />
            <ReactPaginate
                pageCount={pageCount}
                onPageChange={(data) => {
                    const selectedPage = data.selected + 1;
                    setActivePage(selectedPage);
                }}
                containerClassName={"pagination"}
                activeClassName={"active"}
            />

        </div>
    </>
}

export default function Form8Data() {

    const {allform8Data}=useSelector((state)=>state.form8);
    const [gruhkar,setGruhkar]=useState([]);
    const [panikar,setPanikar]=useState([]);
    const dispatch=useDispatch();

    const navigate = useNavigate();
    const tableRef = useRef();
    const [form8Data,setForm8Data]=useState([]);
    const [searchData,setSearchData]=useState([]);

    const [allData,setAllData]=useState([]);
    const [sortOrder, setSortOrder] = useState('asc');
    const [isTaxReceipt,setIsTaxReceipt]=useState(false);
    const [searchType,setSearchType]=useState("All")
    const [searchText,setSearchText]=useState("")
    const [activePage,setActivePage]=useState(0);
    const [pageCount,setPageCount]=useState(0);
    const [totalRecord,setTotalRecord]=useState(0);
    const [isAcending,setIsAcending]=useState(false);

    const isFetch=useRef(false);


    useEffect(()=>{
        CountPage();
    },[])

    async function ReadAllRecords(pages) {


        let allData = [];

        const requests = [];

        for (let i = 1; i <= pages; i++) {
            const form = new FormData();
            form.append('VilageName', JSON.parse(sessionStorage.getItem('data'))[0].VilageName.trim());
            form.append('searchType', searchType);
            form.append('activePage', i);
            form.append('searchText', searchText);

            const request = fetch(BaseURL + 'GM.php/ReadForm8', {
                method: 'POST',
                body: form
            }).then(res => res.text())
                .then(data => {
                    if (data !== "[]") {
                        try {
                            const parsedData = JSON.parse(data);
                            if (typeof parsedData === 'string') {
                                const innerParsed = JSON.parse(parsedData);
                                innerParsed.forEach((item) => {
                                    allData.push(item);
                                });
                            }
                        } catch (e) {
                            console.error("Parsing error:", e);
                        }
                    }
                }).catch(err => {
                    console.error("Fetch error:", err);
                });

            requests.push(request);
        }

        // Wait for all fetch requests to complete
        await Promise.all(requests);
        setForm8Data(allData);
        dispatch(addAllInFrom8(allData));
    }

    async function CountPage() {
        if(allform8Data.length>0){
            setForm8Data(allform8Data);
            setPageCount(allform8Data.length);
            return 0;
        };
        // 1. Guard clause checking the ref
        if (isFetch.current === true) return;
        isFetch.current = true;

        setActivePage(0);

        let CountPage=0;
        // 2. Prepare Form Data
        const sessionData = JSON.parse(sessionStorage.getItem('data'));
        const villageName = sessionData?.[0]?.VilageName || '';

        let form = new FormData();
        form.append('VilageName', villageName);
        form.append('searchType', searchType);
        form.append('searchText', searchText);

        // 3. Async Fetch Request
        try {
            const res = await fetch(BaseURL + 'GM.php/ReadForm8Count', {
                method: 'POST',
                body: form
            });

            const data = await res.text(); // Await the raw text payload

            // 4. Double parsing logic preserved safely
            const parsedData = JSON.parse(data);
            const innerData = JSON.parse(parsedData);
            const total = parseInt(innerData[0].total, 10);

            setTotalRecord(total);

            // 5. Cleaned up pagination math
            if (total % 20 === 0) {
                CountPage=Math.floor(total / 20);
            } else {
                CountPage=Math.floor(total / 20+1);
            }
            setPageCount(CountPage);
            await ReadAllRecords(CountPage);
        } catch (e) {
            console.error("Fetch or parsing error:", e);
        }
    }

    const handlePrint = () => {
        const printWindow = window.open("", "", "height=800,width=1000");

        printWindow.document.write(`
    <html>
      <head>
        <title>Print Table</title>
        <style>
          @media print {
            @page {
              size: legal portrait;
              margin: 5px;
              margin-top: 100px;
            }

            th:first-child,
            td:first-child {
              display: none;
            }

            body {
              margin: 0;
            }
          }

          body {
            font-family: Arial, sans-serif;
            padding: 10px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            page-break-inside: auto;
          }

          th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
            vertical-align: top;
          }

          th {
            background-color: #3f51b5;
            color: white;
            font-weight: bold;
          }

          tr:nth-child(even) {
            background-color: #f2f2f2;
          }

          tr:hover {
            background-color: #e0e0e0;
          }
        </style>
      </head>
      <body>
        ${document.getElementById("TableList").innerHTML}
      </body>
    </html>
  `);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };


    const handleSortClick = () => {
        // Current order ko toggle karein (asc -> desc ya desc -> asc)
        const nextOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(nextOrder);

        // Current form8Data ko copy karke sort karein
        const sorted = [...form8Data].sort((a, b) => {
            const valA = (a && a.Property_No !== undefined && a.Property_No !== null)
                ? String(a.Property_No).trim()
                : '';
            const valB = (b && b.Property_No !== undefined && b.Property_No !== null)
                ? String(b.Property_No).trim()
                : '';

            // Empty values ko hamesha LAST me rakhne ke liye
            if (!valA && !valB) return 0;
            if (!valA) return 1;
            if (!valB) return -1;

            // Natural numeric comparison (1, 2, 2/1, 3, 10...)
            const comparison = valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' });

            // Ascending / Descending check
            return nextOrder === 'asc' ? comparison : -comparison;
        });

        // States Update Karein
        setForm8Data(sorted);
        setAllData(sorted);
    };

    function Search() {
        SearchRecord(searchType,searchText);
    }

    function SearchRecord(type, text) {

        if (!text?.trim() || type === "All") {
            setSearchData([]);
            return;
        }

        // Text normalize
        const normalizeText = (value) => {
            return String(value ?? "")
                .normalize("NFC")
                .toLowerCase()
                .trim()
                .replace(/\s+/g, " ");
        };

        // Property number ke liye separators remove
        const normalizePropertyNo = (value) => {
            return String(value ?? "")
                .toLowerCase()
                .replace(/[\s\/\-\.]/g, "");
        };

        const searchText = normalizeText(text);

        const filteredData = form8Data
            .filter(item => {

                let value = item[type] ?? "";

                // Property_No search
                if (type === "Property_No") {

                    const propertyNo = normalizePropertyNo(value);
                    const searchNo = normalizePropertyNo(searchText);

                    return propertyNo.includes(searchNo);
                }

                // Owner_Name search
                const valueText = normalizeText(value);

                // Normal partial match
                if (valueText.includes(searchText)) {
                    return true;
                }

                // Multiple words me koi bhi word match
                const searchWords = searchText.split(" ");

                return searchWords.some(word =>
                    word.length >= 2 && valueText.includes(word)
                );
            })
            .sort((a, b) => {

                // Exact/starting match ko upar lao
                const search = normalizeText(text);

                const aValue = normalizeText(a[type]);
                const bValue = normalizeText(b[type]);

                const aExact = aValue === search ? 3 :
                    aValue.startsWith(search) ? 2 :
                        aValue.includes(search) ? 1 : 0;

                const bExact = bValue === search ? 3 :
                    bValue.startsWith(search) ? 2 :
                        bValue.includes(search) ? 1 : 0;

                return bExact - aExact;
            });

        setSearchData(filteredData);
    }


    function Add() {
        navigate("/admin/Form8AddInformation");
    }

    return <div>
        <div className="mt-2 p-3 card">
            <h1>Form8</h1>
            ग्रामपंचायत नमूना ८
        </div>

        <div className="card">
            <h4>Total:{totalRecord}</h4>
            <h4>Totel allform8Data:{allform8Data.length}</h4>
            <h4>Search :{searchData.length}</h4>
            <div className="d-flex justify-content-between">
                <div className="mt-2 p-3">
                    {/*<span className={"m-1"}><MdMenu/></span>*/}
                    <button onClick={handlePrint} className="btn btn-primary m-1">Print All</button>
                    <button onClick={handleSortClick} className="btn btn-primary">Sort</button>
                    {/*<button onClick={()=>setIsTaxReceipt(true)} className="btn btn-primary m-1">Tax Receipt</button>*/}
                </div>
                <div className="mt-2 p-3">
                    <select onChange={(e)=>setSearchType(e.target.value)} className="form-control d-inline-block w-auto" name="selSearch">
                        <option value="All">All</option>
                        <option value="Property_No">मालमत्ता क्र.</option>
                        {/*<option value="GramPanchayat_Name1">गाव</option>*/}
                        <option value="Owner_Name">घरमालकाचे नाव</option>
                    </select>
                    <input onChange={(e)=>setSearchText(e.target.value)} className="form-control d-inline-block w-auto mx-2" />
                    <button onClick={Search} className="btn btn-primary d-inline-block">Search</button>
                    <button onClick={Add} className="btn btn-primary d-inline-block mx-2">Add</button>
                </div>
            </div>

            <Table form8Data={searchData.length>0?searchData:form8Data}
                   tableRef={tableRef}
                   isAcending={isAcending}
            />
            <ReactPaginate
                pageCount={pageCount}
                onPageChange={(data) => {
                    const selectedPage = data.selected + 1;
                    setActivePage(selectedPage);
                }}
                containerClassName={"pagination"}
                activeClassName={"active"}
            />



        </div>

    </div>
}

const Table=React.memo(({tableRef,form8Data,isAcending}) =>{
    const navigate = useNavigate();
    const dispatch=useDispatch();
    const [show, setShow] = useState(false);
    const [data,setData]=useState({id:null,index:null});
    function Edit(item) {
        dispatch(setForm8Data(item));
        navigate("/admin/Form8EditInformation");
    }
    function Print(item) {
        dispatch(setForm8Data(item));
        navigate("/admin/Form8PrintPage");
    }

    function Delete(item,index) {
        setData({
            id:item.id,
            index: index
        })
        setShow(true)
    }

    return <>
        <div id={"TableList"} className={"w-100 form-table"}>
            <table ref={tableRef} className="table custom-table2">
                <thead>
                <tr>
                    {/*-----1----*/}
                    <td></td>
                    {/*-----2----*/}
                    <td>Sr.No.</td>
                    {/*-----3----*/}
                    <td>अनु क्र.</td>
                    {/*-----4----*/}
                    <td>मालमत्ता क्र.</td>
                    {/*-----5----*/}
                    <td>गाव</td>
                    {/*-----6----*/}
                    <td>घरमालकाचे नाव</td>
                    {/*-----7----*/}
                    <td>पत्नीचे नाव</td>
                    {/*-----8----*/}
                    <td>भोगवटदाराचे नाव</td>
                    {/*-----9----*/}
                    <td>पु.प</td>
                    {/*-----10----*/}
                    <td>उ. द.</td>
                    {/*-----11----*/}
                    <td>मालमत्तेचे वर्णन</td>
                    {/*-----12----*/}
                    <td>सा.पाणीकर</td>
                    {/*-----13----*/}
                    <td>वी.पाणीक</td>
                    {/*-----14----*/}
                    <td>गृहकर</td>
                    {/*-----15----*/}
                    <td>एकूण कर</td>
                </tr>
                </thead>
                <tbody>
                {
                    [...form8Data]
                        .map((item, index) => (
                            <tr key={`row-${index}`}>
                                <td>
                                    <span onClick={() => { Edit(item) }} className="m-1 pointer-curser"><FaEdit /></span>
                                    <span onClick={() => { Print(item) }} className="m-1 pointer-curser"><IoMdPrint /></span>
                                    <span onClick={() => { Delete(item, index) }} className="m-1 pointer-curser"><MdDelete /></span>
                                </td>
                                <td>{index + 1}</td>
                                <td>{item.Sr_No || "0"}</td>
                                <td>{item.Property_No}</td>
                                <td>{item.GramPanchayat_Name1}</td>
                                <td>{item.Owner_Name}</td>
                                <td>{item.Wife_Name}</td>
                                <td>{item.Occupant_Name}</td>
                                <td>{JSON.parse(item.Col8).total_area_east_west1}</td>
                                <td>{JSON.parse(item.Col8).total_area_north_south1}</td>
                                <td>{JSON.parse(item.ExtendData)[0].Col9}</td>
                                <td>{JSON.parse(item.Box).box5}</td>
                                <td>{JSON.parse(item.Box).box6}</td>
                                <td>{parseFloat(JSON.parse(item.ExtendData)[0].Col19_Gruhakar).toFixed(3)}</td>
                                <td>{parseFloat(item.Col20).toFixed(3)}</td>
                            </tr>
                        ))
                }

                {/*{*/}
                {/*    form8Data.map((item,index)=>(*/}
                {/*        <tr key={`row-${index}`}>*/}
                {/*            <td>*/}
                {/*                <span onClick={()=>{Edit(item)}} className={"m-1 pointer-curser"}><FaEdit/></span>*/}
                {/*                <span onClick={()=>{Print(item)}} className={"m-1 pointer-curser"}><IoMdPrint/></span>*/}
                {/*                <span onClick={()=>{Delete(item,index)}} className={"m-1 pointer-curser"}><MdDelete /></span>*/}
                {/*            </td>*/}
                {/*            /!*=======1======*!/*/}
                {/*            <td>{index+1}</td>*/}
                {/*            /!*=======2======*!/*/}
                {/*            <td>{item.Sr_No}</td>*/}
                {/*            /!*=======3======*!/*/}
                {/*            <td>{item.Property_No}</td>*/}
                {/*            /!*=======4======*!/*/}
                {/*            <td>{item.GramPanchayat_Name1}</td>*/}
                {/*            /!*=======5======*!/*/}
                {/*            <td>{item.Owner_Name}</td>*/}
                {/*            /!*=======6======*!/*/}
                {/*            <td>{item.Wife_Name}</td>*/}
                {/*            /!*=======7======*!/*/}
                {/*            <td>{item.Occupant_Name}</td>*/}
                {/*            /!*=======7======*!/*/}
                {/*            <td>{JSON.parse(item.Col8).total_area_east_west1}</td>*/}
                {/*            /!*=======8======*!/*/}
                {/*            <td>{JSON.parse(item.Col8).total_area_north_south1}</td>*/}
                {/*            /!*=======9======*!/*/}
                {/*            <td>{JSON.parse(item.ExtendData)[0].Col9}</td>*/}
                {/*            /!*=======10======*!/*/}
                {/*            <td>{JSON.parse(item.Box).box5}</td>*/}
                {/*            /!*=======11======*!/*/}
                {/*            <td>{JSON.parse(item.Box).box6}</td>*/}
                {/*            /!*=======12======*!/*/}
                {/*            <td>{parseFloat(JSON.parse(item.ExtendData)[0].Col19_Gruhakar).toFixed(3)}</td>*/}
                {/*            /!*=======13======*!/*/}
                {/*            <td>{parseFloat(item.Col20).toFixed(3)}</td>*/}
                {/*        </tr>*/}
                {/*    ))*/}
                {/*}*/}
                </tbody>
            </table>
        </div>
        <DeletePopup data={data} setShow={setShow} show={show}/>
    </>
})

const DeletePopup = ({ data, show, setShow }) => {
    const dispatch=useDispatch();

    const handleClose = () => setShow(false);

    const handleConfirm = () => {
        let form = new FormData();
        form.append('Id',data.id);

        fetch(BaseURL + 'GM.php/DeleteForm8', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                window.location.reload();
                //alert(data.index);
               // dispatch(deleteForm8DataByIndex(data.index));
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });


        setShow(false);
    };

    return (
        <>
            {show && (
                <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation</h5>
                                <button type="button" className="btn-close" onClick={handleClose}></button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to delete?</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-danger" onClick={handleConfirm}>
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

